import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiResponse } from '@card-software/library';
import { ProductionGroup } from '../../models/production/production-group.model';

@Injectable({
  providedIn: 'root',
})
export class ProductionGroupProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = `${environment.proxyUrls.productionApi}/api/v1/production-group`;

  getAll(): Observable<ApiResponse<ProductionGroup[]>> {
    return this.httpClient.get<ApiResponse<ProductionGroup[]>>(`${this.baseUrl}/all`, {
      headers: { Accept: 'application/json' },
    });
  }
}
